export const notFoundI18nSegment = (): string => 'not-found';
